var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarnCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 0.33252C18.4518 0.33252 23.6668 5.56035 23.6668 11.9992C23.6668 18.4404 18.4518 23.6659 12.0002 23.6659C5.56016 23.6659 0.333496 18.4404 0.333496 11.9992C0.333496 5.56035 5.56016 0.33252 12.0002 0.33252ZM12.0002 15.4187C11.4402 15.4187 10.9852 15.8737 10.9852 16.4337C10.9852 16.9937 11.4402 17.4604 12.0118 17.4604C12.5718 17.4604 13.0268 16.9937 13.0268 16.4337C13.0268 15.8737 12.5718 15.4187 12.0002 15.4187ZM12.0002 6.55085C11.4402 6.55085 10.9735 7.01869 10.9735 7.57752V12.7342C10.9735 13.2954 11.4402 13.7492 12.0002 13.7492C12.5602 13.7492 13.0152 13.2954 13.0152 12.7342V7.57752C13.0152 7.01869 12.5602 6.55085 12.0002 6.55085Z",
    fill: "#F5AD5D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarnCircle);
export default __webpack_public_path__ + "static/media/warn-circle.0163477d.svg";
export { ForwardRef as ReactComponent };